import Cookies from 'js-cookie';

// assets (Tabler icons only)
import {
  IconHome,
  IconCalendarEvent,
  IconMail,
  IconFileUpload,
  IconFileInvoice,
  IconPhoneCall,
  IconAntennaBars5,
  IconChecklist,
  IconNotebook,
  IconPhoneCheck,
  IconUsers,
  IconUser,
  IconFileStack,
  IconNotification,
  IconMenu,
  IconCategory,
  IconReceipt,
  IconUserPlus,
  IconBuilding, // replacing building.svg
  IconBed, // replacing booking.svg (room/booking)
  IconReport, // replacing complaints.svg
  IconCalendar, // replacing attendance.svg
  IconDoor, // replacing room2.svg
  IconId,
  IconCurrencyRupee
} from '@tabler/icons-react';
import { IndianRupee } from 'lucide-react';


// constant
const icons = {
  IconHome,
  IconCalendarEvent,
  IconMail,
  IconFileUpload,
  IconFileInvoice,
  IconPhoneCall,
  IconAntennaBars5,
  IconChecklist,
  IconNotebook,
  IconPhoneCheck,
  IconUsers,
  IconUser,
  IconFileStack,
  IconNotification,
  IconMenu,
  IconCategory,
  IconReceipt,
  IconUserPlus,
  IconBuilding,
  IconBed,
  IconReport,
  IconCalendar,
  IconDoor,
  IconId,
  IndianRupee,
  IconCurrencyRupee
};

// ==============================|| SUB ADMIN USERS DASHBOARD MENU ITEMS ||============================== //
const subdashboard = {
  type: 'Customer',
  get children() {
    let category = '';
    try {
      const rawUser = Cookies.get('user');
      const rawCategoryType = Cookies.get('CategoryType');
      if (rawUser) {
        const parsed = JSON.parse(decodeURIComponent(rawUser));
        category = String(parsed?.category || parsed?.buildingCategory || '').toLowerCase();
      }
      if (!category && rawCategoryType) {
        category = String(rawCategoryType).toLowerCase();
      }
    } catch (e) {
      console.warn('Failed to parse user category cookies:', e);
    }

    const allItems = [
      {
        id: 'default',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard/default',
        icon: icons.IconHome,
        breadcrumbs: false
      },
      {
        id: '13',
        title: 'New Room Request',
        type: 'item',
        url: '/dashboard/Booking',
        icon: icons.IconBed,
        breadcrumbs: false
      },
      {
        id: '14',
        title: 'My Room Details',
        type: 'item',
        url: '/dashboard/room_details',
        icon: icons.IconDoor,
        breadcrumbs: false
      },
      {
        id: '07',
        title: 'My Hostel Attendance',
        type: 'item',
        url: '/dashboard/attendance',
        icon: icons.IconCalendar,
        breadcrumbs: false
      },
      // {
      //   id: '08',
      //   title: 'Fee Management',
      //   type: 'item',
      //   url: '/dashboard/feemanagment',
      //   icon: icons.IconCurrencyRupee ,
      //   breadcrumbs: false
      // },
      {
        id: '15',
        title: 'Complaints',
        type: 'item',
        url: '/dashboard/complaints',
        icon: icons.IconReport,
        breadcrumbs: false
      },
      {
        id: '16',
        title: 'Student Gate Pass',
        type: 'item',
        url: '/dashboard/studentGatePass',
        icon: icons.IconId,
        breadcrumbs: false
      }
    ];

    if (category === 'pg') {
      return allItems.filter(
        (item) =>
          item.title === 'Dashboard' ||
          item.title === 'My Room Details' ||
          item.title === 'Complaints'
      );
    }

    return allItems;
  }
};

export default subdashboard;

